import * as React from 'react';
import { cn } from '@/lib/utils';

/**
 * Mid-century Textarea — same boundary contract as Input (charcoal 1.5px,
 * orange on focus, no layered ring). Min-height stays generous for
 * multi-line entry (drafts, prompt edits).
 */
const Textarea = React.forwardRef<HTMLTextAreaElement, React.ComponentProps<'textarea'>>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          'flex min-h-[96px] w-full rounded-card border-[1.5px] border-charcoal bg-cream px-3 py-2',
          'text-[16px] font-sans text-charcoal leading-relaxed',
          'placeholder:text-charcoal-soft/60',
          'transition-colors',
          'focus:outline-none focus-visible:outline-none focus-visible:border-orange',
          'disabled:cursor-not-allowed disabled:opacity-50',
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Textarea.displayName = 'Textarea';

export { Textarea };
